export default __webpack_public_path__ + "static/media/Ostali 13.e7efa97c.jpg";